import { render, staticRenderFns } from "./TeamCards.vue?vue&type=template&id=6f08fe75&scoped=true&"
import script from "./TeamCards.vue?vue&type=script&lang=js&"
export * from "./TeamCards.vue?vue&type=script&lang=js&"
import style0 from "./TeamCards.vue?vue&type=style&index=0&id=6f08fe75&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f08fe75",
  null
  
)

export default component.exports